import { FunctionComponent } from 'react'
import { logger } from '../../../utils/dccLogger'
import useOnMount from '../../../hooks/useOnMount'
import config from '../../../config'

const E3DScriptLoader: FunctionComponent = () => {
  useOnMount(() => {
    const loadE3DScript = () => {
      try {
        const E3D_EXHIBITION_URL = config.E3DEX_APP_URL

        if (document.querySelector(`script[src="${E3D_EXHIBITION_URL}"]`)) {
          return
        }

        const exhibitionScript = document.createElement('script')
        exhibitionScript.type = 'module'
        exhibitionScript.src = `${E3D_EXHIBITION_URL}`
        document.body.appendChild(exhibitionScript)

        exhibitionScript.onerror = () => {
          logger.error('Failed to load E3D exhibition script')
        }
      } catch (error) {
        logger.error(`Error loading E3D script: ${error}`)
      }
    }

    loadE3DScript()
  })

  return null
}

export default E3DScriptLoader 